// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","tab_area":"KJ0yev","AniFadeIn":"mXs3Iv","AniFadeOut":"H12uu8","AniRotate":"_6zEEUi","AniPlaceholderFadeOut":"z_qszO"};